module.exports = __webpack_public_path__ + "static/media/11_DSC0834.fc7ab9db.jpg";